/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Move_FailedInputs */

const en_toast_move_failed = /** @type {(inputs: Toast_Move_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The item could not be moved.`)
};

const de_toast_move_failed = /** @type {(inputs: Toast_Move_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Vorgang konnte nicht verschoben werden.`)
};

/**
* | output |
* | --- |
* | "The item could not be moved." |
*
* @param {Toast_Move_FailedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const toast_move_failed = /** @type {((inputs?: Toast_Move_FailedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Move_FailedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_toast_move_failed(inputs)
	return en_toast_move_failed(inputs)
});